import { ModalidadeGarantiaComponent } from './modalidade-garantia.component';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { ModalidadeGarantiaRoutingModule } from './modalidade-garantia-routing.module';
import { ModalidadeGarantiaHistoricoComponent } from './historico/modalidade-garantia-historico.component';
import { ModalPercentuaisGarantidosComponent } from './modal-percentuais-garantidos/modal-percentuais-garantidos.component';
import { NgbModalModule, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { ModalOutrasGarantiasComponent } from './modal-outras-garantias/modal-outras-garantias.component';
import { ModalValidacaoInadimplenciaComponent } from './modal-validacao-inadimplencia/modal-validacao-inadimplencia.component';
import { ModalTaxaAtualizacaoGarantiaComponent } from './modal-taxa-atualizacao-garantia/modal-taxa-atualizacao-garantia.component';
import { ModalEncerrarTaxaAtualizacaoGarantiaComponent } from './modal-encerrar-taxa-atualizacao-garantia/modal-encerrar-taxa-atualizacao-garantia.component';

@NgModule({
  imports:[
      SharedModule,
      BrowserModule,
      CommonModule,
      ModalidadeGarantiaRoutingModule,
      NgbModalModule,
      NgbNav
  ],
  declarations:[
      ModalidadeGarantiaComponent,
      ModalidadeGarantiaHistoricoComponent,
      ModalPercentuaisGarantidosComponent,
      ModalOutrasGarantiasComponent,
      ModalValidacaoInadimplenciaComponent,
      ModalTaxaAtualizacaoGarantiaComponent,
      ModalEncerrarTaxaAtualizacaoGarantiaComponent
  ],
  providers:[

  ]
})
export class ModalidadeGarantiaModule {}
